import type { Complaint } from "@/views/complaint/complaint";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: Complaint) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as Complaint; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Complaint }) {
  addAuthRequestFields(response.data);
  if (response.data.investigation) {
    //TODO - would we want to not do this if investigations are already present? (rerunnability)
    response.data.investigations = JSON.parse(response.data.investigation);
  } else {
    response.data.investigations = [];
  }

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Complaint }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Complaint) {
  // Add seconds to the time so that the BE will parse it correctly.
  if (data.receivedTime?.length === 5) {
    data.receivedTime += ":00";
  }

  if (!data.receivedDate) {
    data.receivedDate = null;
  }

  if (!data.receivedTime) {
    data.receivedTime = null;
  }

  if (data.investigations) {
    data.investigation = JSON.stringify(data.investigations);
  }
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Complaint) {
  //TODO: Mask Bug Office and mobile number only set to be undefined to fix formkit bug. Once formkit resolves bug, remove both of these if statements
  if (!data.complainantMobileNumber) {
    data.complainantMobileNumber = undefined;
  }
  if (!data.complainantOfficeNumber) {
    data.complainantOfficeNumber = undefined;
  }
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {
  //TODO: Mask Bug Office and mobile number only set to be undefined to fix formkit bug. Once formkit resolves bug, remove both of these if statements
  if (!data.complainantMobileNumber) {
    data.complainantMobileNumber = null;
  }
  if (!data.complainantOfficeNumber) {
    data.complainantOfficeNumber = null;
  }
}
